/**
 * 🔒 Session Mode Store - Persistência de modo por sessão de aba
 * 
 * Usa sessionStorage para manter o modo ativo durante refreshes,
 * mas NÃO entre abas (por segurança, especialmente para admin).
 * 
 * Benefícios:
 * - Admin: Refresh na mesma aba mantém modo admin
 * - Segurança: Fechar aba/navegador limpa o modo admin
 * - Novas abas: Usam preferredMode (não-admin) do localStorage
 */

import type { ViewMode } from '@/types/roles';

const SESSION_MODE_KEY = 'auli-session-mode';

export const sessionModeStore = {
  /**
   * Obtém o modo salvo na sessão atual da aba
   */
  get: (): ViewMode | null => {
    try {
      const mode = sessionStorage.getItem(SESSION_MODE_KEY);
      if (mode && ['teacher', 'family', 'student', 'admin'].includes(mode)) {
        return mode as ViewMode;
      }
      return null;
    } catch {
      // sessionStorage pode falhar em contextos privados
      return null;
    }
  },

  /**
   * Salva o modo atual na sessão da aba
   */
  set: (mode: ViewMode | null): void => {
    try {
      if (mode) {
        sessionStorage.setItem(SESSION_MODE_KEY, mode);
      } else {
        sessionStorage.removeItem(SESSION_MODE_KEY);
      }
    } catch {
      // Silently fail - não crítico
    }
  },

  /**
   * Limpa o modo da sessão (usado no logout)
   */
  clear: (): void => {
    try {
      sessionStorage.removeItem(SESSION_MODE_KEY);
    } catch {
      // Silently fail
    }
  },
};
